/* unplugin-vue-components disabled */import script from "./TravelGroupDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./TravelGroupDetails.vue?vue&type=script&setup=true&lang=js"

import "./TravelGroupDetails.vue?vue&type=style&index=0&id=2a8aa178&lang=scss"

const __exports__ = script;

export default __exports__